// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"b71044a5","715":"164fa2b2"}[chunkId] + ".chunk.js";
};